export function freshShowLocation() {
    return new Promise((resolve, reject) => {
        const fail = (message) => reject(Object.assign(new Error(message), { showLocationError: true }));
        if (!navigator.geolocation) { fail('GPS indisponível. Não é possível entrar na sala do show.'); return; }
        navigator.geolocation.getCurrentPosition(position => {
            if (!Number.isFinite(position.coords.accuracy) || position.coords.accuracy > 100) {
                fail('O GPS está sem precisão suficiente. Confira sua localização e tente novamente.'); return;
            }
            resolve({ latitude: position.coords.latitude, longitude: position.coords.longitude, accuracy: position.coords.accuracy, location_timestamp: Math.trunc(position.timestamp) });
        }, error => fail(error.code === 1 ? 'Permita o GPS para se conectar ao show.' : 'Não foi possível atualizar sua localização. Você foi desconectado da sala.'), { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 });
    });
}

export function isShowLocationError(error) {
    return error.showLocationError || error.response?.data?.disconnected === true;
}
